import React from 'react'

interface ScriptProps {
  innerHTML: string
}

export default function Script({ innerHTML }: ScriptProps): null {
  React.useEffect(() => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.innerHTML = innerHTML

    let intervalId: ReturnType<typeof setInterval>

    const appendScript = () => document.body.appendChild(script)

    const isIreDefined = () => {
      const dependencyScript: HTMLScriptElement | null = document.querySelector(
        '[src="https://utt.impactcdn.com/A3731510-f9bc-44f8-baa0-d78df44a8c681.js"]'
      )

      return !!dependencyScript && window.ire !== undefined
    }

    const onLoad = () => {
      // If the dependency script has been loaded before the page is fully loaded, we're good
      if (isIreDefined()) {
        appendScript()
        return
      }

      // Otherwise, retry
      let retries = 0
      intervalId = setInterval(() => {
        retries += 1

        // Stop after 3 retries
        if (retries === 3) {
          clearInterval(intervalId)
        }

        if (isIreDefined()) {
          clearInterval(intervalId)
          appendScript()
        }
      }, 1000)
    }

    // The session API might respond after the document is loaded.
    // Pages could be navigated via Internal Links (react routing).
    // In both the cases,
    // a `window.onload` to append the script won't work
    if (document.readyState === 'complete') {
      onLoad()
    } else {
      // The Impact Universal Tag injects an external script the `ire` function
      // depends on. Therefore, we add this `load` event listener to ensure that
      // Universal Tag is executed before trying to access the `ire` function.
      window.addEventListener('load', onLoad)
    }

    return () => {
      script.remove()
      window.removeEventListener('load', onLoad)
      clearInterval(intervalId)
    }
  }, [innerHTML])

  return null
}
